import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import DropdownList from "react-widgets/DropdownList";
import ComponentLoading from "../../commonComponents/ComponentLoading";
import MainButton from "../../commonComponents/MainButton";
import { Tooltip, TooltipProps, tooltipClasses } from "@mui/material";
// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DocumentTransportForm from "./DocumentTransportForm";
import { addEntitie, addFlowToStepRemote, addFlowToStepLocal, setExtractedData } from "../../redux/actions/analysisActions";
import { ToastWarn, ToastSuccess } from "../../commonComponents/ToastHelper";

const DocumentForm = (props) => {
  // const hiddenindex = 0;
  const [hidden, setHidden] = useState([true]);
  // const flow_type_meta = useSelector((state) => (state.flow.flow_type_meta ? state.flow.flow_type_meta : null));

  const analysis_id = useSelector((state) => (state.analysis.analysis_id ? state.analysis.analysis_id : null));
  const extracted_data = useSelector((state) => (state.analysis ? state.analysis.extracted_data : null));

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const addEntitie_rd = (item) => dispatch(addEntitie(item));
  const addFlowToStepRemote_rd = (item) => dispatch(addFlowToStepRemote(item));
  const addFlowToStepLocal_rd = (item) => dispatch(addFlowToStepLocal(item));
  const setExtractedData_rd = (item) => dispatch(setExtractedData(item));
  // const saveData_rd = (item) => dispatch(saveData(item));

  const [loading, setLoading] = useState(false);
  const [flow_type_error, set_flow_type_error] = useState(null);
  const [weight_error, set_weight_error] = useState(null);
  const [price_error, set_price_error] = useState(null);
  const [distance_error, set_distance_error] = useState(null);

  function StrSplit(text) {
    const newText = text.split("\\n");

    return newText;
  }

  const handleAddFlowStep = async (current) => {
    const item = {
      fileName: extracted_data[props.step_index].fileName,
      flow_meta: current.flow_type,
      step_index: Math.abs(props.step_index - 6),
      analysis_id: analysis_id,
      price: parseFloat(current.price.mentionText.toString().replace(",", "")),
      amount:
        current.flow_category.name === "K_Transports"
          ? parseFloat(current.distance.rows[0].elements[0].distance.text.toString().replace("km", "")) * parseFloat(current.weight.mentionText.toString().replace(",", ""))
          : parseFloat(current.weight.mentionText.toString().replace(",", "")),
      // ingredients_size: Object.values(analysis_data.ingredients).length,
    };
    if (item.step_index === 4) {
      item.type = "add_ingredient";
      // add ingredients
      // console.log("toto", item);
      // const flow_uid = await addIngredientLocal_rd(item);
      // // item.flow_uid = flow_usid; // ??
      // await addIngredient_rd(item);
    } else {
      item.type = "add_flow";
      console.log("current", item);
      const flow_uid = await addFlowToStepLocal_rd(item);
      item.flow_uid = flow_uid;
      await addFlowToStepRemote_rd(item);
      // await setExtractedData_rd(null);
    }
  };

  return (
    <div className="flex flex-col w-[350px] h-screen pb-[200px] space-y-[20px] pl-[40px] overflow-auto">
      {Object.values(extracted_data[props.step_index][props.selectedIndex].selected_entities).map((x, i) => (
        <>
          <DocumentTransportForm
            flow_type_error={flow_type_error}
            set_flow_type_error={set_flow_type_error}
            weight_error={weight_error}
            set_weight_error={set_weight_error}
            price_error={price_error}
            set_price_error={set_price_error}
            distance_error={distance_error}
            set_distance_error={set_distance_error}
            key={i}
            step_index={props.step_index}
            fileName={extracted_data[props.step_index][props.selectedIndex].fileName}
            entitie={x}
            hiddenindex={i}
            hidden={hidden}
            setHidden={setHidden}
            index={i}
          />
        </>
      ))}

      <div className="flex flex-col w-[300px] justify-center items-center">
        <div className="h-[40px] w-[300px] mt-[20px] bg-[#F3F5F7] rounded-lg flex">
          <button
            className="h-[40px] w-[305px] border-dotted border-r-[1px] border-[#F3F5F7] flex justify-center items-center"
            onClick={async () => {
              setLoading(true);
              addEntitie_rd({ fileName: extracted_data[props.step_index].fileName, step_index: props.step_index });
              setLoading(false);
            }}
          >
            {loading ? <ComponentLoading height={20} style={"flex items-center justify-center ml-[11px]"} /> : <Plus height={15} />}
            <p className="text-sm w-max text-gray-400">Ajouter un transport</p>
          </button>
        </div>

        <div class="flex items-center w-[200px] justify-center mt-8 h-[40px]">
          <MainButton
            disabled={true}
            title={"Valider"}
            callback={async () => {
              // const [weight, setWeight] = useState(props.entitie.weight && props.entitie.weight.mentionText ? parseFloat(props.entitie.weight.mentionText.toString().replace(",", "")) : "");
              // const [price, setPrice] = useState(props.entitie.price && props.entitie.price.mentionText ? parseFloat(props.entitie.price.mentionText.toString().replace(",", "")) : "");
              // props.entitie.distance && props.entitie.distance.rows[0].elements[0].distance.text
              //   ? parseFloat(props.entitie.distance.rows[0].elements[0].distance.text.toString().replace("km", ""))
              //   : "";

              // Validate data
              // lopp through selected_entities
              let is_all_okay = true;
              await Object.values(extracted_data[props.step_index][props.selectedIndex].selected_entities).forEach(async (x, i) => {
                console.log(x, i);

                // type
                if (!x.flow_type || !x.flow_type.name || x.flow_type.name === "Choisir...") {
                  ToastWarn("Entité " + (i + 1) + ": type " + x.flow_category.title + " incorrecte.");
                  set_flow_type_error("Valeur incorrecte");
                  is_all_okay = false;
                }

                // weight
                if (!x.weight || !x.weight.mentionText || x.weight.mentionText.length == 0) {
                  ToastWarn(x.flow_category.name === "K_Transports" ? "Entité " + (i + 1) + ": poids incorrecte." : "Entité " + (i + 1) + ": quantité incorrecte.");
                  set_weight_error("Valeur incorrecte");
                  is_all_okay = false;
                }

                // distance
                if (!x.distance || !x.distance.rows[0].elements[0].distance.text === 0 || x.distance.rows[0].elements[0].distance.text.length === 0) {
                  ToastWarn("Entité " + (i + 1) + ": distance incorrecte.");
                  set_distance_error("Valeur incorrecte");
                  is_all_okay = false;
                }

                // price
                if (!x.price || !x.price.mentionText || x.price.mentionText.length == 0) {
                  ToastWarn("Entité " + (i + 1) + ": prix incorrecte.");
                  set_price_error("Valeur incorrecte");
                  is_all_okay = false;
                }

                // if (x.flow_category.name === "K_Transports") {
                //   console.log("toto", parseFloat(x.distance.rows[0].elements[0].distance.text.toString().replace("km", "")) * parseFloat(x.weight.mentionText.toString().replace(",", "")));
                // }

                // setExtractedData_rd(null);
              });

              // console.log("toto", res_copy);
              if (is_all_okay) {
                Object.values(extracted_data[props.step_index][props.selectedIndex].selected_entities).forEach(async (x, i) => {
                  await handleAddFlowStep(x);
                });
                // props.setLoading(true);

                const removeKey = (key, { [key]: _, ...rest }) => rest;

                const res_copy = Object.assign({}, extracted_data);
                const cleaned_level_1 = removeKey(props.selectedIndex, res_copy[props.step_index]);
                let new_dict = {};
                Object.values(cleaned_level_1).map((x, i) => {
                  new_dict[i] = x;
                });
                res_copy[props.step_index] = new_dict;

                // if no more element, set to null [needed for view condition in uploadPanel]
                if (Object.keys(res_copy[props.step_index]).length === 0) {
                  res_copy[props.step_index] = null;
                }
                setExtractedData_rd(res_copy);

                console.log("trototto", res_copy);

                console.log("extracted_data", extracted_data);

                // ToastSuccess("Procédé(s) du document ajouté(s).");
              }

              // delete actual document

              // Save to the cloud

              // console.log(props.entities);
              // const weight = get_weight();
              // console.log("weight", parseFloat(weight.mentionText.replace(",", "")));
              // console.log("confidnce", parseFloat(weight.confidence).toFixed(2) * 100);
              // console.log("entites", props.selected_entities);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DocumentForm;
